// This file is generated. Do not update manually!
import { Resource } from '../client/resource.js';
export class NotificationPreferences extends Resource {
    path = 'notification_preferences';
    entity = 'notification_preferences';
    /**
     * Fetch a user's notification preferences. If a user does not disable a channel
     * explicitly, we would send notifications through that channel as long as your
     * project is enabled.
     *
     * @param options - override client request options.
     * @returns
     **/
    get(options) {
        return this.request({
            method: 'GET',
        }, options);
    }
    update(dataOrOptions, options) {
        return this.request({
            method: 'PUT',
        }, dataOrOptions, options);
    }
}
//# sourceMappingURL=notification-preferences.js.map